angular.module('elogbooksControllers').controller('LayoutController', function ($scope, $rootScope, $state) {
    $scope.$state = $state;
    let vm = this;

    const faviconPostFix = '-favicon.svg';
    const faviconPath = (theme) => '/' + theme + faviconPostFix;
    vm.favicon = faviconPath('cafm');

    $scope.$watch(function() {
        return $rootScope.theme;
    }, function(newValue, oldValue) {
        if (newValue !== oldValue) {
            document.title = newValue === 'fs' ? 'Vantify Facilities Services' : 'Vantify CAFM';

            const next = faviconPath(newValue);
            if (next !== vm.favicon) {
                vm.favicon = next;
            }
        }
    });

    // Loader indicator for when the dashboard is loading
    $scope.showLoader = true;
});
